import classnames from 'classnames';
import * as React from 'react';
import { spinner, size, inner } from './spinner.css.js';

/**
  Indicates that something is being loaded.
 */
const Spinner = ({ size: size$1 = 'large', className }) => {
    return (React.createElement("span", { className: classnames(spinner, size[size$1], className) },
        React.createElement("span", { className: inner })));
};

export { Spinner };
